import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
    errorInfo: null
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, errorInfo: null };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          backgroundColor: '#1a1a2e',
          color: '#fff',
          padding: '20px',
          fontFamily: 'monospace'
        }}>
          <div style={{
            maxWidth: '800px',
            margin: '0 auto',
            padding: '20px',
            backgroundColor: '#dc2626',
            borderRadius: '8px',
            border: '3px solid #fbbf24'
          }}>
            <h1 style={{ color: '#fbbf24', marginBottom: '16px', fontSize: '24px' }}>
              ⚠️ ERRO CRÍTICO NA APLICAÇÃO
            </h1>
            <p style={{ marginBottom: '16px', color: '#fef3c7' }}>
              Um erro inesperado ocorreu. Copie as informações abaixo para diagnóstico:
            </p>
            
            <div style={{
              backgroundColor: '#000',
              padding: '16px',
              borderRadius: '4px',
              overflow: 'auto',
              marginBottom: '16px'
            }}>
              <p style={{ color: '#f87171', fontWeight: 'bold', marginBottom: '8px' }}>
                Mensagem: {this.state.error?.message}
              </p>
              <p style={{ color: '#fcd34d', fontSize: '12px', marginBottom: '8px' }}>
                Nome: {this.state.error?.name}
              </p>
              <pre style={{ color: '#9ca3af', fontSize: '11px', whiteSpace: 'pre-wrap' }}>
                {this.state.error?.stack}
              </pre>
              {this.state.errorInfo && (
                <pre style={{ color: '#60a5fa', fontSize: '11px', whiteSpace: 'pre-wrap', marginTop: '16px' }}>
                  Component Stack:{'\n'}{this.state.errorInfo.componentStack}
                </pre>
              )}
            </div>

            <button
              onClick={() => window.location.reload()}
              style={{
                backgroundColor: '#fbbf24',
                color: '#1a1a2e',
                padding: '12px 24px',
                borderRadius: '6px',
                border: 'none',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '14px'
              }}
            >
              🔄 Recarregar Página
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
